import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Demo } from '../demo-content/demo-content.model';

@Component({
  selector: 'document-mini-info',
  templateUrl: './document-mini-info.component.html',
  styleUrls: ['./document-mini-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class DocumentMiniInfoComponent implements OnInit {

  @Input() data : Demo;

  constructor() { }

  ngOnInit(): void {
  }

}
